import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import successAudio from "./audio/success.mp3";
import errorAudio from "./audio/error.mp3";
import infoAudio from "./audio/info.mp3";
import "./toast.css";

const playToastAudio = (audio) => {
  if (!audio || typeof audio.play !== "function") {
    return;
  }

  const playPromise = audio.play();
  if (playPromise && typeof playPromise.catch === "function") {
    playPromise.catch(() => {});
  }
};

export const ToastMessage = async (TYPE, MESSAGE) => {
  const toastStyle = {
    marginTop: "20px",
    width: "80%",
  };
  const progressClassName = "toast-progress-white";
  const Success = new Audio(successAudio);
  const Error = new Audio(errorAudio);
  const Info = new Audio(infoAudio);

  if (TYPE === 1) {  //info
    toast.info(MESSAGE, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      style: toastStyle,
      progressClassName,
    });
    playToastAudio(Info);
  } else if (TYPE === 2) {  //success
    toast.success(MESSAGE, {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      style: toastStyle,
      progressClassName,
    });
    playToastAudio(Success);
  } else if (TYPE === 3) {  //error
    toast.error(MESSAGE, {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      style: toastStyle,
      progressClassName,
    });
    playToastAudio(Error);
  }
};
